import React, { Component } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@material-ui/core'

class ModalAdoptionMode extends Component {
  constructor(props) {
    super(props)

    this.state = {
      adoptionModeOption: 'alwaysUpdateChild',
    }
  }

  handleAdoptionMode = (event) => {
    this.setState({
      adoptionModeOption: event.target.value,
    })
  }

  //Save in Local Storage the selected adoption mode
  activeAdoptionMode = () => {
    localStorage.setItem('ADOPTION_MODE', JSON.stringify(this.state.adoptionModeOption))
    this.props.activeAdoptionMode && this.props.activeAdoptionMode()
  }

  render() {
    const { open, close } = this.props
    const { adoptionModeOption } = this.state

    return (
      <Dialog open={open} className={'container-small-modal'}>
        <DialogTitle>Adoption Mode</DialogTitle>
        <DialogContent className={'size-small-modal'}>
          <span className={'text-description-adoption-mode'}>
            Would you like to use the same method for Adopting? Or ask everytime? Creating overrides
            preserve the child’s current values. You will have a chance to confirm changes.
          </span>
          <p>
            <a
              className={'link-article'}
              href={'https://support.blaze.me/hc/en-us/search?utf8=%E2%9C%93&query=master+catalog'}
              target={'_blank'}
            >
              Visit Help Article
            </a>
          </p>
          <div className="container-input-radios">
            <RadioGroup
              aria-label="adoption-mode-options"
              name="adoption-mode-options"
              value={adoptionModeOption}
              onChange={this.handleAdoptionMode}
            >
              <FormControlLabel
                value="alwaysUpdateChild"
                control={<Radio />}
                label="Always Update Child"
              />
              <FormControlLabel
                value="alwaysCreateOverrides"
                control={<Radio />}
                label="Always Create Overrides - Do not update the child with parent values"
              />
            </RadioGroup>
          </div>
        </DialogContent>
        <DialogActions className="container-buttons-adoption-mode">
          <Button onClick={close} className="button-white-and-red">
            <span className="button-text">Cancel</span>
          </Button>
          <Button onClick={this.activeAdoptionMode} className="button-blue-and-white">
            <span className="button-text">Continue</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ModalAdoptionMode



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalAdoptionMode.js